module.exports = __webpack_public_path__ + "./img/results_not_found_icon.svg";